import { render, staticRenderFns } from "./abc.vue?vue&type=template&id=265b6220&scoped=true"
import script from "./abc.vue?vue&type=script&lang=js"
export * from "./abc.vue?vue&type=script&lang=js"
import style0 from "./abc.vue?vue&type=style&index=0&id=265b6220&prod&scoped=true&lang=css"
import style1 from "./abc.vue?vue&type=style&index=1&id=265b6220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b6220",
  null
  
)

export default component.exports